import classNames from 'classnames';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { marketing } from 'config/global';
// TODO: swap for an Android render once available — reuses the iPhone mockup for now.
import imgPhone from 'assets/images/v3-hero-phone.png';
import { PlatformRow } from './components/PlatformRow';
import { StoreBadge } from './components/StoreBadge';

const AndroidGlyph = () => (
  <svg viewBox="0 0 24 24" className="gly">
    <path d="M5 16a1 1 0 0 0 1 1h1v3a1 1 0 0 0 2 0v-3h6v3a1 1 0 0 0 2 0v-3h1a1 1 0 0 0 1-1V9H5zM3 9.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0zM19 9.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0zM7.6 8a4.4 4.4 0 0 1 8.8 0z" />
  </svg>
);

const GooglePlayGlyph = () => (
  <svg viewBox="0 0 24 24">
    <path d="M3.6 2.3a1 1 0 0 0-.6.9v17.6a1 1 0 0 0 .6.9l9.8-9.7zM14.5 13.2l2.7 2.7-3.3 1.9-2.5-2.5zM18.4 9.3l2.8 1.6a1 1 0 0 1 0 1.7l-2.8 1.6-2.9-2.4zM5.2 21.4l9.2-5.3-2.3-2.3z" />
  </svg>
);

const PhoneStage = () => {
  const t = useTranslations();
  return (
    <div className={styles.stage}>
      <Image
        src={imgPhone}
        alt={t('pages.download.android.imageAlt')}
        width={440}
        height={916}
        className={styles.phone}
        sizes="262px"
      />
      <div className={styles.badge}>
        <span className={styles.badgeIcon}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 12a8 8 0 0 1 14-5l2 2M20 12a8 8 0 0 1-14 5l-2-2" />
          </svg>
        </span>
        {t('pages.download.android.badge')}
      </div>
    </div>
  );
};

// Download page — MindFeed for Android.
export const Section39 = () => {
  const t = useTranslations();
  return (
    <PlatformRow
      id="android"
      reversed
      icon={<AndroidGlyph />}
      tag={t('pages.download.android.tag')}
      title={t('pages.download.android.title')}
      description={t('pages.download.android.description')}
      features={[
        t('pages.download.android.feature1'),
        t('pages.download.android.feature2'),
        t('pages.download.android.feature3'),
      ]}
      actions={
        <StoreBadge
          icon={<GooglePlayGlyph />}
          small={t('pages.download.android.storeSmall')}
          big="Google Play"
          href={marketing.googlePlayUri}
          newTab
        />
      }
      visual={<PhoneStage />}
    />
  );
};

const styles = {
  stage: 'relative z-[2] flex items-center justify-center',
  phone: [
    'h-auto w-[236px] rounded-[42px] lg:w-[262px]',
    'drop-shadow-[0_18px_36px_rgba(20,30,60,0.14)]',
    'marketing-dark:drop-shadow-[0_40px_70px_rgba(2,8,30,0.6)]',
  ].join(' '),
  badge: classNames(
    'absolute bottom-[30px] -left-20 z-[6] hidden items-center gap-[9px] whitespace-nowrap rounded-xl lg:flex',
    'border px-[13px] py-[9px] text-[12.5px] font-semibold',
    'border-[#DEDEDE] bg-white text-mf-off-black-600 shadow-[0_16px_36px_rgba(20,30,60,0.16)]',
    'marketing-dark:border-white/[0.14] marketing-dark:bg-[#0b1430] marketing-dark:text-white',
    'marketing-dark:shadow-[0_16px_36px_rgba(0,0,0,0.45)] animate-floaty-slow motion-reduce:animate-none',
  ),
  badgeIcon:
    'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-[7px] bg-mf-blue [&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:fill-none [&>svg]:stroke-white [&>svg]:stroke-2',
};
